// extracted by mini-css-extract-plugin
export var card = "_8o-0";
export var expandedCard = "_8o-2";
export var paginated = "_8o-1";